import React, { useEffect, useState } from 'react';
import { Checkbox, SelectionControlLabel, FormGroup } from '@one-thd/sui-atomic-components';
import { Input } from '@thd-olt-component-react/input';
import Field from '../../common/Field/Field';
import FieldErrorText from '../../common/FieldErrorText/FieldErrorText';
import { useStore } from '../../../store';

export const BenefitsCheckboxes = ({
  benefits,
  checkedItems,
  setCheckedItems,
  setOtherChecked,
  otherChecked,
  resetOtherBenefits
}) => {
  return (
    <div className="create-job-posting__checkbox-container">
      <FormGroup>
        {benefits.map((item, index) => (
          <SelectionControlLabel label={item}>
            <Checkbox
              key={index}
              id={item}
              onChange={() => {
                if (item === 'No Benefits Offered' || !checkedItems.includes('No Benefits Offered')) {
                  handleCheckboxChange({
                    item,
                    setCheckedItems,
                    setOtherChecked,
                    otherChecked,
                    resetOtherBenefits
                  });
                }
              }}
              checked={checkedItems.includes(item)}
              disabled={item !== 'No Benefits Offered' && checkedItems.includes('No Benefits Offered')}
            />
          </SelectionControlLabel>
        ))}
      </FormGroup>
    </div>
  );
};

export const handleCheckboxChange = ({
  item,
  setCheckedItems,
  setOtherChecked,
  otherChecked,
  resetOtherBenefits
}) => {

  if (item === 'No Benefits Offered') {
    setCheckedItems((prevItems) => (prevItems.includes(item) ? [] : ['No Benefits Offered']));
    setOtherChecked(false);
    resetOtherBenefits();
    return;
  }
  setCheckedItems((prevItems) => {
    if (item === 'Other') {
      setOtherChecked(!otherChecked);
      resetOtherBenefits();
    }
    if (prevItems?.includes(item)) {
      // if the item is already in checkedItems, remove it
      return prevItems?.filter((i) => i !== item);
    }
    // if the item is not in checkedItems, add it
    return [...prevItems, item];
  });
};

export const JobPostingBenefits = ({
  required,
  value,
  dirty,
  description,
  errorText,
  label,
  didError,
  updateJobPostingAttr
}) => {

  const { staticDataStore: { benefits } } = useStore();

  const [checkedItems, setCheckedItems] = useState(value?.choices || []);
  const [otherChecked, setOtherChecked] = useState(value?.choices?.includes('Other') || false);
  const [otherBenefit, setOtherBenefit] = useState(value?.other || '');

  useEffect(() => {
    updateJobPostingAttr({
      choices: checkedItems,
      other: otherChecked ? otherBenefit : ''
    });
  }, [checkedItems, otherChecked, otherBenefit]);

  const resetOtherBenefits = () => {
    setOtherBenefit('');
  };

  return (
    <Field
      label={label}
      dirty={dirty}
      description={description}
      showError={didError}
      required={required}
    >
      <BenefitsCheckboxes
        otherChecked={otherChecked}
        setOtherChecked={setOtherChecked}
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
        benefits={benefits}
        resetOtherBenefits={resetOtherBenefits}
      />
      {otherChecked && (
        <div className="create-job-posting__other-benefit">
          Please specify other benefits:
          <Input
            type="text"
            placeholder="Additional benefits"
            value={otherBenefit}
            onChange={setOtherBenefit}
          />
        </div>
      )}
      {didError && (
        <FieldErrorText hidden={false}>
          {errorText || (otherChecked ? 'Please specify your other benefit' : 'Please select an Employee Benefits option')}
        </FieldErrorText>
      )}
    </Field>
  );
};
